import servicesUtils from "../../../utils/servicesUtils";
import { useMutation } from "react-query";

function useExitWorkspace() {
  return useMutation((id) => servicesUtils.getService(`/workspaces/${id}/exit/`));
}

export default useExitWorkspace;
